<template>
  <card no-body class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
    <template slot="header">
      <div class="d-flex justify-content-between">
        <h3 class="mb-0 mt-2">{{ title }}</h3>
      </div>
    </template>
    <div>
      <b-collapse visible id="filters">
        <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap mt-4"
        >
          <b-row>
            <b-col md="2">
              <el-select
                class="select-primary pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </b-col>
            <b-col md="3">
              <el-select
                class="select-primary pagination-select"
                v-model="filters.category"
                placeholder="Category"
                @change="filterCategory"
              >
                <el-option
                  class="select-primary"
                  label="Select a Category"
                  value=""
                ></el-option>
                <el-option
                  class="select-primary"
                  v-for="category in categories"
                  :key="category"
                  :label="category"
                  :value="category"
                >
                </el-option>
              </el-select>
            </b-col>
            <b-col md="2">
              <el-select v-model="year">
                <el-option v-for="year in years"
                  :key="year.label"
                  :label="year.label"
                  :value="year.value">
                </el-option>
              </el-select>
            </b-col>

            <b-col md="3">
              <base-input v-model="searchQuery"
                prependIcon="fas fa-search"
                placeholder="Search...">
              </base-input>
            </b-col>
            <b-col md="2">
              <b-button variant="danger" @click="$emit('exportFinancials')">Export</b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-collapse>
      <b-card-body>
        <span class="text-danger small"><em>*Rows in red are incomplete financials imported from QuickBooks. Please update these financials with the proper Category.</em></span>
      </b-card-body>
      <b-table responsive small :busy="isBusy" :items="tableData" :perPage="pagination.perPage" :currentPage="pagination.currentPage" :fields="visibleColumns" :filter="searchQuery">
        <template #cell(date)="row">
          {{ row.item.formatted_date }}
        </template>

        <template #cell(type)="row">
          {{ row.item.type | capitalize }}
        </template>

        <template #cell(month)="row">
          {{ row.item.date }}
        </template>

        <template #cell(confirmed)="row">
          <span v-if="row.item.confirmed"><i class="fas fa-check"></i></span>
          <span v-else></span>
        </template>

        <template #cell(description)="row">
          {{ row.item.description }}
        </template>

        <template #cell(amount)="row">
          <span v-if="row.item.type == 'revenue'" class="text-success">{{ row.item.amount | currency }}</span>
          <span v-else>({{ row.item.amount | currency }})</span>
        </template>

        <template #cell(account_used)="row">
          {{ row.item.account_used }}
        </template>

        <template #cell(category)="row">
          {{ row.item.category }}
        </template>

        <template #cell(recurring)="row">
          <span v-if="row.item.recurring"><i class="fas fa-check"></i></span>
          <span v-else></span>
        </template>

        <template #cell(primary_source)="row">
          {{ row.item.primary_source }}
        </template>
        
        <template #cell(actions)="row">
          <b-dropdown text="Actions" size="sm" variant="info" boundary="viewport">
            <b-dropdown-item variant="primary" @click="handleEdit(row)" v-if="canAddEdit"><i class="fa fa-edit"></i> Edit</b-dropdown-item>
            <b-dropdown-item variant="danger" @click="handleDelete(row)" v-if="canAddEdit"><i class="fa fa-trash"></i> Delete</b-dropdown-item>
            <b-dropdown-item variant="success" @click="confirm(row)" v-if="canAddEdit && row.item.confirmed == false"><i class="fa fa-check"></i> Confirm</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>
    <div
      slot="footer"
      class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
    >
      <div class="">
        <p class="card-category">
          Showing {{ from + 1 }} to {{ to }} of {{ total }} entries

          <span v-if="selectedRows.length">
            &nbsp; &nbsp; {{selectedRows.length}} rows selected
          </span>
        </p>

      </div>
      <base-pagination
        class="pagination-no-border"
        :current="pagination.currentPage"
        :per-page="pagination.perPage"
        :total="total"
        @change="paginationChanged($event)"
      >
      </base-pagination>
    </div>
  </card>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2';
import { Select, Option } from 'element-ui';
import { format } from 'date-fns'
import { BasePagination } from '@/components';
import paginationMixin from '../Tables/PaginatedTables/paginationMixin';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [paginationMixin, errorsMixin],
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  props: {
    id: null,
    title: null,
    data: [],
    categories: null,
    primarySources: null,
    tableColumns: [],
    isBusy: null,
    userRoute: null,
    canAddEdit: null
  },
  data() {
    return {
      propsToSearch: [],
      tableData: this.data,
      selectedRows: [],
      editable: false,
      filters: {
        category: '',
      },
      year: new Date().getFullYear(),
      years: [
        { value: new Date().getFullYear() - 6, label: new Date().getFullYear() - 6 },
        { value: new Date().getFullYear() - 5, label: new Date().getFullYear() - 5 },
        { value: new Date().getFullYear() - 4, label: new Date().getFullYear() - 4 },
        { value: new Date().getFullYear() - 3, label: new Date().getFullYear() - 3 },
        { value: new Date().getFullYear() - 2, label: new Date().getFullYear() - 2 },
        { value: new Date().getFullYear() - 1, label: new Date().getFullYear() - 1 },
        { value: new Date().getFullYear(), label: new Date().getFullYear() },
        { value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1 },
        { value: new Date().getFullYear() + 2, label: new Date().getFullYear() + 2 },
        { value: new Date().getFullYear() + 3, label: new Date().getFullYear() + 3 },
      ],
    };
  },
  computed: {
    visibleColumns() {
      return this.tableColumns.filter(field => field.visible)
    }
  },
  methods: {
    paginationChanged(page) {
      this.pagination.currentPage = page
    },
    handleEdit(row) {
      this.$emit('updateFinancial', row.item);
    },
    handleDelete(row) {
      swal.fire({
        title: 'Are you sure?',
        text: `You won't be able to revert this!`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        confirmButtonText: 'Yes, delete it!',
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(row);
          swal.fire({
            title: 'Deleted!',
            text: `Your expenses has been deleted.`,
            type: 'success',
            showConfirmButton: false,
            timer: 1500,
            icon: 'success'
          });
        }
      });
    },
    async deleteRow(row) {
      axios.delete(this.userRoute + "/expenses/" + row.item.id)
      .then(response => {
        this.tableData.splice(row.index, 1);
      })
      .catch(error => {
        this.error(error);
      });
    },
    handleCancel() {
      this.editable = null;
    },
    filterCategory() {
      this.tableData = this.data.filter(tableRow => {
        const category = tableRow.category.toString().toLowerCase();
        const searchCategory = this.filters.category.toLowerCase();

        return category.includes(searchCategory);
      });
    },
    confirm(row) {
      axios.patch(this.userRoute + "/expenses/" + row.item.id, {
        confirmed: true
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
        this.$emit('getExpenses');
      })
      .catch(error => {
        // error
      });
    }
  },
  watch: {
    data(to, from) {
      this.tableData = to;
    },
    year(to, from) {
      this.$emit('updateYear', to);
    },
  }
};
</script>
<style>
  .no-border-card .card-footer{
    border-top: 0;
  }
  .current-month {
    background-color: rgba(200, 53, 69, .7);

  }
</style>